import {defineStyle} from '@chakra-ui/styled-system';

import {defineGraphCSSVars} from './helpers';

const {
  size: $size,
  color: $color,
  radii: $radii,
  lineHeight: $lineHeight,
  padding: $padding,
  shadow: $shadow,
} = defineGraphCSSVars(`control`, [`size`, `color`, `radii`, `lineHeight`, `padding`, `shadow`]);

// Those are defined on the top level component
export const controlCssVars = {
  [$size.variable]: `sizes.32`,
  [$color.variable]: `colors.text.base`,
  [$radii.variable]: `radii.md`,
  [$lineHeight.variable]: `lineHeights.base`,
  [$padding.variable]: `space.0`,
  [$shadow.variable]: `shadows.5`,
};

export const controlStyle = defineStyle({
  [`&.react-flow__controls-button`]: {
    display: `flex`,
    alignItems: `center`,
    justifyContent: `center`,
    lineHeight: $lineHeight.reference,
    padding: $padding.reference,
    width: $size.reference,
    height: $size.reference,
    borderRadius: $radii.reference,
    boxShadow: $shadow.reference,
  },
});
